import { useMemo } from 'react'

import { useLocation } from '@cedarjs/router'
import { routes } from '@cedarjs/router'

import { useMyCompaniesQuery } from 'src/fetch/companies'

import Navigation, { NavElement, NavGroupKey, NavItem } from '../Navigation/Navigation'

type Props = {
  isNavGroupOpenMap: Map<string, boolean>
  onToggleNavGroupIsOpen: (key: string) => void
}
export const ApplicantCompanyNavItem = ({ isNavGroupOpenMap, onToggleNavGroupIsOpen }: Props) => {
  const { pathname, search } = useLocation()
  const pathnameWithParameters = `${pathname}${search}`
  const { companies } = useMyCompaniesQuery()

  const companyNavItems: NavItem[] = useMemo(
    () =>
      companies.map((c) => {
        const route = routes.viewCompanyProfile({ uuid: c.uuid })
        return {
          internalRoute: route,
          isActive: pathnameWithParameters === route,
          title: c.name,
        }
      }),
    [companies, pathnameWithParameters]
  )

  const navElements: NavElement[] = useMemo(
    () => [
      {
        icon: 'FaBuildings',
        items: [
          {
            internalRoute: routes.myCompanies(),
            isActive: pathname === routes.myCompanies(),
            title: 'Overview',
          },
          ...companyNavItems,
        ],
        key: NavGroupKey.Companies,
        title: 'Companies',
      },
    ],
    [companyNavItems, pathname]
  )

  return (
    <Navigation
      elements={navElements}
      isNavGroupOpenMap={isNavGroupOpenMap}
      onToggleIsOpen={onToggleNavGroupIsOpen}
    />
  )
}

export default React.memo(ApplicantCompanyNavItem)
